  var products = {
	tk: 4549318738060,
    sp: 4601200410764,
    tk_bulk: 4601129795724,
    sp_bulk: 4601217450124,
	max: {
		tk: 15,
        sp: 18,
        tk_bulk: 10,
        sp_bulk: 10
	},
	totals: {
		tk: 0,
        sp: 0,
        tk_bulk: 0,
        sp_bulk: 0
	},
	parse: function(){
      	products.totals.tk = 0;
        products.totals.sp = 0;
        products.totals.tk_bulk = 0;
        products.totals.sp_bulk = 0;
      
      	var req = jQuery.getJSON('/cart.js', function(cart) {
 
          for(i=0;i<cart.items.length;i++){
              if(cart.items[i]['product_id'] == products.tk){
                  products.totals.tk += cart.items[i]['quantity'];
              } else if(cart.items[i]['product_id'] == products.sp){
                  products.totals.sp += cart.items[i]['quantity'];
              } else if(cart.items[i]['product_id'] == products.tk_bulk){
                  products.totals.tk_bulk += cart.items[i]['quantity'];
              } else if(cart.items[i]['product_id'] == products.sp_bulk){
                  products.totals.sp_bulk += cart.items[i]['quantity'];
              }
            
          }
 
		}).always(products.alert);
        
        
	},
	alert: function(){
		var content = [];
		if(products.totals.tk > products.max.tk){
			content.push('We will not charge shipping for the <b>' + products.totals.tk + ' individual ADA Toe Kick items</b> in your cart at this time.');
		}
        if(products.totals.sp > products.max.sp){
			content.push('We will not charge shipping for the <b>' + products.totals.sp + ' individual Sink Panel Bracket items</b> in your cart at this time.');
		}
		if(products.totals.sp_bulk > products.max.sp_bulk){
			content.push('We will not charge shipping for the <b>' + products.totals.sp_bulk + ' Sink Panel Bracket cases</b> in your cart at this time.');
		}
      if(products.totals.tk_bulk > products.max.tk_bulk){
			content.push('We will not charge shipping for the <b>' + products.totals.tk_bulk + '  ADA Toe Kick cases</b> in your cart at this time.');
		}
        if(!content.length){
        	$('#cartAlert').remove();
            return;
        }
        var rendered = '';
        for(i=0;i<content.length;i++){
			rendered += '<li>'+content[i]+'</li>';
        }
      	if($('#cartAlert').length){
      		$('#cartAlert').html('<h3>We will contact you with an additional shipping quote</h3><ul>'+rendered+'</ul><p>You\'ve selected more of these items than normal, and we think we can save you money by packaging these in a bulk shipment. <b>We will generate a shipping separate shipping quote for these and contact you to verify before processing your order.</b></p>');
        } else {
          var alertBox = '<div id="cartAlert">'+ content +'</div>';
          $('.cart__shipping').after(alertBox);
        }
		
	}
}
var cartCheck = setInterval(products.parse, 2000);
